<template>
  <div class="logged-in judge-layout">
    <Navigation />
    <router-view></router-view>
  </div>
</template>

<script>
import Navigation from '@/components/navigation/Navigation'

export default {
  name: 'JudgeLayout',
  components: {
    Navigation
  },
  mounted () {
    this.$store
      .dispatch('admin/GET_EVENTS')
      .then(res => {
        if (res.data.events.length > 0) {
          this.$store.commit('saveEvents', res.data.events)

          let event = res.data.events.filter(item => {
            return item.activeEvent
          })[0]
          this.$store.commit('saveEvent', event)
        }
      })
  }
}
</script>
